import { ImplementerType } from "../../types";

export const implementerTypes: { [type in ImplementerType]: string } = {
  CIVIL_ASSOCIATION: "Asociación civil",
  GOVERNMENT: "Organismo gubernamental",
  CONSULTANT: "Consultores",
  INTERNATIONAL_INSTITUTION: "Organismo internacional"
};
